import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

const DashboardView = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("loggedUser"));

  if (!user || user.role !== "Dashboard View") {
    navigate("/dashboard-login");
    return null;
  }

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body text-center">

          <h4 className="fw-bold text-primary mb-2">
            Welcome, {user.name}
          </h4>

          <p className="text-muted mb-4">
            Role: Dashboard View
          </p>

          <div
            className="alert alert-warning fw-semibold"
            style={{ fontSize: "18px" }}
          >
            🚧 This dashboard is under process
          </div>

          <button
            className="btn btn-outline-danger"
            onClick={() => {
              localStorage.removeItem("loggedUser");
              navigate("/dashboard-login");
            }}
          >
            Logout
          </button>

        </div>
      </div>
    </div>
  );
};

export default DashboardView;
